import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Transparency pill (the Airbnb-style "total price up front" affordance):
 * a quiet glass capsule announcing that displayed prices are all-in —
 * airline taxes in the fare, Defera's service & hold fees in the trip
 * total. Purely declarative; the numbers it describes are produced by the
 * all-in pricing work on the search cards and the Review trip total, so
 * this component must never appear on a surface whose price is NOT all-in
 * (e.g. stays with hotel-collected fees due at check-in).
 */
export default function AllInPricePill({ className }) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] py-1.5 pl-1.5 pr-3.5',
        'shadow-[0_0_18px_-6px_rgba(52,211,153,0.25)]',
        className,
      )}
    >
      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-400/15 px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.08em] text-emerald-300">
        <Sparkles className="h-2.5 w-2.5" aria-hidden />
        New
      </span>
      <span className="text-[13px] font-normal leading-none text-white/85">
        Grand total — taxes &amp; fees included
      </span>
    </div>
  );
}
